import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import styles from './styles'

const Focuser = withStyles(styles)(props => {
  const { contents, type, inc, count, classes } = props
  const data = contents.filter(x => x.type === type)[count[type]].content
  inc(type)
  return (
    data && (
      <div className={classes.page}>
        <div className={classes.contents}>
          <div className={classes.focuser}>
            <div className={classes.layout}>
                {data.primary.section_image.localFile && (
                  <div
                    className={classes.focusSectionImage}
                    style={{
                      backgroundImage: `url(${
                        data.primary.section_image.localFile.childImageSharp
                          .original.src
                      })`,
                    }}
                  />
                )}

                {data.items.map(item => {
                  return (
                    <div>
                      {item.section_image && (
                        <div
                          className={classes.contenterImage}
                          src={
                            item.section_image.localFile.childImageSharp
                              .original
                          }
                          style={{
                            backgroundImage: `url(${
                              item.section_image.localFile
                                .childImageSharp.original.src
                            })`,
                          }}
                        />
                      )}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.section_text && item.section_text.html,
                        }}
                        className={classes.richText}
                      />
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      </div>
    )
  )
})

export default withStyles(styles)(Focuser)



// WEBPACK FOOTER //
// ./src/components/scaffolding/widgets/focuser.js